module.exports = __webpack_public_path__ + "img/hi-five.bc8a47c8.svg";